import { schema } from 'normalizr';
import { toDoSchema } from './../todos/schema';

export const toDoListSchema = new schema.Entity('toDoLists', {
  toDos: [toDoSchema],
});
